import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { MessageService } from 'src/app/core/services/broadcast/message-service';
import { QueryMessageService } from 'src/app/core/services/broadcast/MessageDispatchingService';
import { InvoiceService } from 'src/app/core/services/data/invoice.service';
import { QuicksearchService } from 'src/app/core/services/data/quicksearch.service';
import { SandboxService } from 'src/app/core/services/data/sandbox.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { QuickSearchResults } from 'src/app/shared/entities/QuickSearchResults';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-adjustments-home',
  templateUrl: './adjustments-home.component.html',
  styleUrls: ['./adjustments-home.component.scss'],
})
export class AdjustmentsHomeComponent implements OnInit, OnDestroy {
  urlDomain: string = '';
  currentInvoiceNumber: string = '';
  subInvoiceDetail: Subscription;
  invoiceDetail: QuickSearchResults;
  turnOnSpinner: boolean = false;
  currentInvoiceDetail: QuickSearchResults;
  invoicePeriod: string = '';
  customerName: string = '';
  isGB: boolean = false;

  //Services
  _destroyRefService = inject(DestroyRef);
  _msgService = inject(QueryMessageService);
  _messageDialogService = inject(MessageDialogService);
  _appGeneralState = inject(AppGeneralStateService);
  _sandboxService = inject(SandboxService);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private quicksearchService: QuicksearchService,
  ) {
    this.urlDomain = environment.UrlDomain;
    const newLocal = (this.turnOnSpinner = false);
    this.getInvoiceNumber();

    this._appGeneralState.canChangeLot = false;
  }

  getInvoiceNumber(): void {
    let invoiceNumber: any = this.route.snapshot.paramMap.get('invoicenumber');

    if (invoiceNumber !== null) {
      const invoiceType: string = invoiceNumber.substring(0, 2);

      this.isGB = invoiceType == 'GB' ? true : false;

      this.currentInvoiceNumber = invoiceNumber;
    }
  }

  setInvoiceDetailData(): void {
    let ii: number = 0;

    //this.invoiceNumber = this.invoiceDetailData.invoiceNumber;
    // this.invoiceAmount = this.invoiceDetailData.rate;
    // this.invoiceBalance = this.invoiceDetailData.currentBalance;

    this._msgService.currentInvoiceBalance = this.currentInvoiceDetail.currentBalance;

    if (this.currentInvoiceDetail.customerName !== '') this.customerName = this.currentInvoiceDetail.customerName;
    else this.customerName = this.currentInvoiceDetail.companyName;

    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    var d = new Date(this.currentInvoiceDetail.invoiceDate);
    var monthName = months[d.getMonth()];
    var year = d.getFullYear();

    this.invoicePeriod = monthName + ', ' + year;
  }

  ngOnInit(): void {
    this.getInvoiceDetail(this.currentInvoiceNumber, this._appGeneralState.currentLotNumber);
  }

  ngOnDestroy(): void {
    this._appGeneralState.canChangeLot = true;
  }

  returnToQuickSearchGrid(): void {
    this.turnOnSpinner = true;
    this.getInvoiceDetailAndUpdateCachedVersion(this.currentInvoiceNumber);
  }

  updateQuickSearchResultsBalancesForCurrentInvoice(): void {
    //get updated detail from G_SearchResults
  }

  getInvoiceDetailAndUpdateCachedVersion(invoiceNumber: string): void {
    let quickSearchResults: QuickSearchResults;

    // 20241030 :: Ken Moss
    // Changed lot number argument below from authService to _appGeneralState
    this.subInvoiceDetail = this.invoiceService
      .getInvoiceDetailByInvoiceNumber(invoiceNumber, this._appGeneralState.currentLotNumber)
      .subscribe({
        next: (results) => (quickSearchResults = results),
        complete: () => {
          this.invoiceDetail = quickSearchResults;
          this.quicksearchService.updateInvoiceDetail(this.invoiceDetail);
          this.router.navigate(['quicksearchhome']);
        },
      });
  }

  //Gets invoice detail upon launch of Invoice Search enable screens
  getInvoiceDetail(invoiceNumber: string, lotNumber): void {
    this.invoiceService
      .getInvoiceDetailByInvoiceNumber(invoiceNumber, lotNumber)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.currentInvoiceDetail = res;
        },
        error: (err: any) => {},
        complete: () => {
          this.setInvoiceDetailData();
        },
      });
  }

  onDisplayInvoice(invoiceNumber: string, lotNumber: string, entityId: string): void {
    this._messageDialogService.snackBarTopCenterTimed(`Generating Invoice for ${invoiceNumber}...`, 2000);

    if (invoiceNumber.substring(0, 2) == 'MI') {
      const invoiceViewUrl = this.router.serializeUrl(
        this.router.createUrlTree(['/viewinvoice', entityId, lotNumber, invoiceNumber]),
      );
      const w = window.open(invoiceViewUrl, '_blank');

      if (!w) {
        console.error('Failed to open new window. Popup blocker might be active.');
      }
    } else {
      const safeEntityId = entityId && entityId.trim().length > 0 ? entityId : 'na';
      const invoiceViewUrl = this.router.serializeUrl(
        this.router.createUrlTree(['/viewinvoice', safeEntityId, lotNumber, invoiceNumber]),
      );
      const w = window.open(invoiceViewUrl, '_blank');

      if (!w) {
        console.error('Failed to open new window. Popup blocker might be active.');
      }
    }
  }
}
